/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { pluralize } from 'sarsaparilla';

import type { SearchResultItem } from '../../api/search/search.types';

// Built once: a results page calls this for every card on every render
const reviewFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
});

const reviewCountFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
});

export function getCardRating(item: SearchResultItem) {
    if (!item.average_rating || !item.number_of_ratings) {
        return {
            averageRating: undefined,
            reviewCount: undefined,
            reviewLabel: undefined,
            ratingAriaLabel: undefined,
        };
    }

    const averageRating = reviewFormatter.format(item.average_rating);
    const reviewCount = reviewCountFormatter.format(item.number_of_ratings);
    const reviewLabel = `${reviewCount} ${pluralize(item.number_of_ratings, 'review', 'reviews')}`;
    const ratingAriaLabel = `Rating: ${averageRating} out of 5 stars based on ${reviewLabel}.`;
    const ratingAriaLabelShort = `${averageRating} stars`;

    return {
        averageRating,
        reviewCount,
        reviewLabel,
        ratingAriaLabel,
        ratingAriaLabelShort,
    };
}
